import './oauth2Fields.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { i18n } from 'core/localization';
import { Section } from 'controls/react/layout/section';
import { Toolbar } from 'controls/react/layout/toolbar';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { OAuth2FieldsProps } from 'areas/administration/authentication/oauth2/types';

const b = b_.with('oauth2-fields');

const SECRET_PLACEHOLDER = '••••••••';

export const OAuth2Fields = observer(({ store }: OAuth2FieldsProps) => {
	const disabled = store.readOnly;

	return (
		<div className={b()}>
			<Section appearance={'frame'} title={i18n('Setup')} childrenPadding={true}>
				<FormEntryNew
					label={i18n('Authorization server (URL)')}
					placeholder={'https://login.example.com/oauth2'}
					hasPlaceholder={true}
					model={store.model}
					validator={store.validator}
					modelField={'authorizationServer'}
					disabled={disabled}
				>
					<AntInput />
				</FormEntryNew>
				<FormEntryNew
					label={i18n('Client identifier')}
					placeholder={i18n('Client ID')}
					hasPlaceholder={true}
					model={store.model}
					validator={store.validator}
					modelField={'clientIdentifier'}
					disabled={disabled}
				>
					<AntInput />
				</FormEntryNew>
				<FormEntryNew
					label={i18n('Client secret')}
					placeholder={store.model.hasClientSecret ? SECRET_PLACEHOLDER : i18n('Client secret')}
					hasPlaceholder={true}
					model={store.model}
					validator={store.validator}
					modelField={'clientSecret'}
					disabled={disabled}
				>
					<AntInput type={'password'} autoComplete={'new-password'} />
				</FormEntryNew>
				<div>
					<FormEntryNew
						label={i18n('Scope')}
						placeholder={i18n('e.g. read write')}
						hasPlaceholder={true}
						model={store.model}
						validator={store.validator}
						modelField={'scope'}
						disabled={disabled}
					>
						<AntInput />
					</FormEntryNew>
					<div className={b('hint')}>{i18n('Space-separated list of requested scopes')}</div>
				</div>
			</Section>
			<Section
				appearance={'frame'}
				title={i18n('Owner credentials')}
				direction={'row'}
				layout={'equal'}
				childrenPadding={true}
			>
				<Toolbar>
					<AntSwitch
						size={'small'}
						value={store.ownerCredentials}
						onChange={(value) => store.switchOwnerCredentials(value)}
						disabled={disabled}
					/>
				</Toolbar>
				{store.ownerCredentials && (
					<>
						<FormEntryNew
							label={i18n('Username')}
							placeholder={i18n('Username')}
							hasPlaceholder={true}
							model={store.model}
							validator={store.validator}
							modelField={'username'}
							disabled={disabled}
						>
							<AntInput autoComplete={'new-password'} />
						</FormEntryNew>
						<FormEntryNew
							label={i18n('Password')}
							placeholder={store.model.hasPassword ? SECRET_PLACEHOLDER : i18n('Password')}
							hasPlaceholder={true}
							model={store.model}
							validator={store.validator}
							modelField={'password'}
							disabled={disabled}
						>
							<AntInput type={'password'} autoComplete={'new-password'} />
						</FormEntryNew>
					</>
				)}
			</Section>
		</div>
	);
});
